import {
  AddExternalUserMutation,
  AddInternalUserv2Mutation,
  getUserV3Response,
  userAccessType,
  countryEnum,
  agencyEnum,
} from 'API';
import { API } from 'aws-amplify';
import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
import { DarkButton } from 'components/style/Global';
import APIContext from 'context/APIContext';
import { useClientContext } from 'context/ClientContext';
import { IoMdClose } from 'react-icons/io';

import { addInternalUserv2, addExternalUser, updateUserAccess } from 'graphql/mutations';
import { useContext, useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import styled, { useTheme } from 'styled-components';
// Styled dropdown matching FormInputContainer style
const StyledDropdown = styled.select`
  font-size: 12px;
  font-family: 'fontRegular';
  padding: 8px;
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.primaryGray};
  background-color: ${({ theme }) => theme.background};
`;
const { REACT_APP_AGENCY } = process.env;
const { REACT_APP_AGENCY_URL } = process.env;

const Modal = styled.div`
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  display: flex;
  justify-content: center;
  align-items: center;

  .wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.4vw;
  }

  .filterTitle {
    margin: 0;
    padding: 0.4vw 0;
  }
  h1 {
    text-align: center;
    font-size: 32px;
    font-weight: normal;
  }

  .form {
    margin: 2vh 4vw 1.5vh;
    border: 2px solid ${({ theme }) => theme.border};
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem 2rem;
  }

  .namesForm {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0.5vw;
  }
  .selectorsForm {
    display: flex;
    flex-direction: column;
    gap: 1vw;
    padding: 0 4vw;
  }
  input,
  label,
  h3 {
    display: block;
    margin-bottom: 1vh;
    margin-top: 0.3vh;
    font-weight: normal;
    color: ${({ theme }) => theme.primaryGray};
    font-family: 'FontRegular', sans-serif;
    font-size: 12px;
  }
  input {
    width: 17vw;
    font-size: 12px;
    padding: 8px;
    border-radius: 7px;
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.primaryGray};
    background-color: ${({ theme }) => theme.background};
  }

  .toggler {
    border: 2px solid ${({ theme }) => theme.border};
    border-radius: 7px;
    padding: 0.9vw;
    height: 40vh;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.border};
      border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.scrollThumb};
      border-radius: 10px;
    }

    legend {
      font-family: 'FontRegular', sans-serif;
      font-weight: 800;
      font-size: 0.7vw;
      margin-right: 1vw;
      color: ${({ theme }) => theme.primaryGray};
      border-bottom: 1px solid ${({ theme }) => theme.border};
    }
  }
  .onoff {
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 0.5vw;
    height: fit-content;

    button {
      all: initial;
      font-family: 'FontRegular', sans-serif;
      font-weight: 800;
      font-size: 1vw;
      color: red;
    }

    section {
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid ${({ theme }) => theme.border};
      width: 100%;
      padding: 5px 15px 0px 15px;
      margin-bottom: 0;
      align-items: center;
      // border-radius: 50px;
      justify-content: space-between;

      legend {
        font-family: 'FontRegular', sans-serif;
        font-weight: 800;
        font-size: 0.7vw;
        margin-right: 1vw;
        color: ${({ theme }) => theme.primaryGray};
        border-bottom: none;
      }
      input[type='radio'] {
        opacity: 0;
        position: fixed;
        width: 0;
      }
      input[type='checkbox'] {
        opacity: 0;
        position: fixed;
        width: 0;
      }
      label {
        display: flex;
        align-items: center;
        /* display: inline-block; */
        padding: 6px;
        margin: 0rem !important;
        font-size: 0.6vw;
        color: ${({ theme }) => theme.secondaryGray};

        /*         cursor: pointer; */
      }
      input[type='radio']:checked + label {
        color: #20c933;
      }
      input[type='checkbox']:checked + label {
        color: #20c933;
      }
    }
    .dashboards {
      border: 1px solid ${({ theme }) => theme.border};
      border-radius: 5px;
      padding: 0px 15px 0px 15px;
    }
    .midChild {
      position: relative;
      padding-right: 0.6vw;
    }
    .midChild:after {
      content: ' ';
      position: absolute;
      border-left: 1px solid ${({ theme }) => theme.border};
      top: 25%;
      right: 0;
      height: 50%;
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  .dashboardGrid {
    /*   display: grid;
  grid-template-columns: repeat(3, max-content); */
    display: flex;
    flex-wrap: wrap;

    input[type='checkbox'] {
      opacity: 0;
      position: fixed;
      width: 0;
    }
    .checked {
      display: flex;
      align-items: center;
      padding: 4px 8px;
      margin: 4px 4px 2px 0px;
      font-size: 0.6vw;
      border: 1px solid ${({ theme }) => theme.border};
      border-radius: 6px;
      width: fit-content;
      font-family: 'FontRegular', sans-serif;
    }

    input[type='checkbox']:checked + label {
      color: #5cdb5c;
    }
  }

  .dashboards {
    margin-bottom: 20px;
    max-width: 800px;
    legend {
      font-family: 'FontRegular', sans-serif;
      font-weight: 800;
      font-size: 0.7vw;
      margin-right: 1vw;
      color: ${({ theme }) => theme.primaryGray};
      border-bottom: none;
    }
  }

  .loaderDiv {
    position: absolute;
    margin-top: -50px;
    margin-left: -50px;
    top: 50%;
    left: 50%;
    width: 400px;
    height: 400px;
  }
`;

const StatusToast = styled.div<{ isError: boolean }>`
  position: absolute;
  bottom: 3vh;
  margin: auto;
  background-color: ${({ theme }) => theme.background};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 7px;
  padding: 0.8vw;
  padding-left: 1.44vw;
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;

  .colorIndicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 0.5vw;
    height: 100%;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
    background-color: ${(props) => (props.isError ? '#FF0021' : '#20C933')};
  }
`;
type Props = {
  setSeeModal(seeModal: boolean): any;
  callBothUsers(): any;
  setModifyUser(modfyUser: any): any;
  setModifyUserInsights(par: any): any;
  setExternalUsers(props: any): any;
  setInternalUsers(props: any): any;
  seeModal: boolean;
  modifyUser: getUserV3Response;
  modifyUserAccessLevels: userAccessType[] | undefined;
  userType: string;
  modifyUserInsights: any;
  typeOfReadAccess: any[];
  setModifyUserAccessLevels(par: any): any;
};
const UserAdminModal2 = (props: Props) => {
  const accessLevels = props.modifyUserAccessLevels; /* ?.filter(e => e.Level !== 'READ_PLUS_ACCESS') */
  const { checkPaddington, activeOrganization } = useClientContext();
  const { getEnvironment } = useContext(APIContext);
  const [firstName, setFirstName] = useState<any>();
  const [lastName, setLastName] = useState<any>();
  const [mail, setMail] = useState<any>();
  const [selectedDashboards] = useState([] as string[]);

  // State za tracking loading za individual client codes
  const [loadingClients, setLoadingClients] = useState<Set<string>>(new Set());

  // State za error handling
  const [errorToast, setErrorToast] = useState<{ show: boolean; message: string }>({
    show: false,
    message: '',
  });

  // State za tracking da li je novi user uspješno kreiran
  const [newUserCreated, setNewUserCreated] = useState<boolean>(false);
  const [newUserEmail, setNewUserEmail] = useState<string>('');

  const [fullList, setFullList] = useState<any>(
    checkPaddington?.Access?.filter((e) => e?.Level?.includes('FULL'))[0]?.Clients?.map((el: any) => {
      delete el.__typename;
      return { ...el, AccessType: 'NONE' };
    }),
  );
  const [readList, setReadList] = useState<any>(
    checkPaddington?.Access?.filter((e) => e?.Level?.includes('READ'))?.flatMap((level: any) =>
      (level?.Clients ?? []).map((el: any) => {
        const { __typename, ...clean } = el;
        return { ...clean, AccessType: 'NONE' };
      }),
    ),
  );
  console.log('lists', readList, fullList, checkPaddington);

  // Add state for new dropdowns
  const [selectedCountry, setSelectedCountry] = useState<countryEnum>(Object.values(countryEnum)[0]);
  const [selectedAgency, setSelectedAgency] = useState<agencyEnum>(Object.values(agencyEnum)[0]);

  useEffect(() => {
    if (checkPaddington && accessLevels) {
      const allTargetReadClients =
        accessLevels?.filter((al) => al?.Level?.includes('READ'))?.flatMap((al) => al?.Clients ?? []) ?? [];
      const fullAccess = accessLevels?.filter((al) => al?.Level?.includes('FULL'))[0];
      const noAccessForFull = accessLevels?.filter((al) => al?.Level?.includes('NO'))[0];

      const full = checkPaddington?.Access?.filter((e) => e?.Level?.includes('FULL'))[0]?.Clients?.map((el: any) => {
        if (fullAccess?.Clients?.some((modifyEl: any) => modifyEl.ClientCode === el.ClientCode))
          return { ...el, AccessType: 'FULL' };
        else if (allTargetReadClients.some((modifyEl: any) => modifyEl.ClientCode === el.ClientCode))
          return { ...el, AccessType: 'READ' };
        else if (noAccessForFull?.Clients?.some((modifyEl: any) => modifyEl.ClientCode === el.ClientCode))
          return { ...el, AccessType: 'NONE' };
        else return { ...el, AccessType: 'NONE' };
      });
      setFullList(full);

      //-------------------READ LIST-----------//
      const allAdminReadClients =
        checkPaddington?.Access?.filter((e) => e?.Level?.includes('READ'))?.flatMap(
          (level: any) => level?.Clients ?? [],
        ) ?? [];
      const noAccess = accessLevels?.filter((al) => al?.Level?.includes('NO'))[0];

      const read = allAdminReadClients.map((el: any) => {
        if (allTargetReadClients.some((modifyEl: any) => modifyEl.ClientCode === el.ClientCode))
          return { ...el, AccessType: 'READ' };
        else if (noAccess?.Clients?.some((modifyEl: any) => modifyEl.ClientCode === el.ClientCode))
          return { ...el, AccessType: 'NONE' };
        else return { ...el, AccessType: 'NONE' };
      });
      setReadList(read);
    }
  }, [checkPaddington, accessLevels]);

  useEffect(() => {
    if (props.modifyUser !== undefined) {
      setFirstName(props.modifyUser.Name);
      setLastName(props.modifyUser.Family_name);
      setMail(props.modifyUser.Email);
    } else if (props.modifyUser === undefined) {
      setFirstName(undefined);
      setLastName(undefined);
      setMail(undefined);
    }
  }, [props.modifyUser]);

  async function handleSaveButton() {
    // Validation for new external users
    if (props.userType === 'EXTERNAL' && !props.modifyUser) {
      // Check if email, firstName, and lastName are valid strings with length > 0
      if (!mail || typeof mail !== 'string' || mail.trim().length === 0) {
        showErrorToast('Email is required.');
        return;
      }
      if (!firstName || typeof firstName !== 'string' || firstName.trim().length === 0) {
        showErrorToast('First name is required.');
        return;
      }
      if (!lastName || typeof lastName !== 'string' || lastName.trim().length === 0) {
        showErrorToast('Last name is required.');
        return;
      }
    }

    const agencies = [
      '@annalect.com',
      '@phd',
      '@omd',
      '@hearts-science',
      '@omnicommediagroup',
      'transact',
      '@drumcph',
      '@omc.com',
    ];

    // Check if any agency is included in the mail for EXTERNAL users
    const isExternalInvalid = props.userType === 'EXTERNAL' && agencies.some((agency) => mail.includes(agency));

    // Check if all agencies are not included in the mail for INTERNAL users
    const isInternalInvalid = props.userType === 'INTERNAL' && agencies.every((agency) => !mail.includes(agency));

    if (isExternalInvalid || isInternalInvalid) {
      showErrorToast('You cannot add this user. Please check the email address.');
      return;
    }

    // Za postojeće korisnike, više nema potrebe za bulk save jer se sve radi real-time
    if (props.modifyUser !== undefined) {
      // Samo zatvorit modal jer su sve promjene već spremljene
      props.setModifyUser(undefined);
      props.setModifyUserInsights([]);
      props.setSeeModal(!props.seeModal);
      props.callBothUsers();
      return;
    }

    // Za nove korisnike - prvo kreiraj korisnika sa osnovnim podacima
    if (!newUserCreated) {
      setLoaderState(false);
      if (props.userType === 'INTERNAL') {
        await createNewInternalUser();
      } else if (props.userType === 'EXTERNAL') {
        await createNewExternalUser();
      }
    } else if (newUserCreated) {
      // Nakon kreiranja korisnika, pristupi client access update putem handleCodes, samo zatvori modal
      finishUserCreation();
    }
  }

  async function createNewInternalUser() {
    try {
      const response = (await API.graphql({
        query: addInternalUserv2,
        variables: {
          Email: mail,
          Environment: getEnvironment,
          Agency: selectedAgency,
          Country: selectedCountry,
          // Clients: [],
          // Dashboards: selectedDashboards,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: AddInternalUserv2Mutation };

      if (response.data.addInternalUserv2?.email) {
        setNewUserCreated(true);
        const mail = response.data.addInternalUserv2.email.startsWith('onewp_')
          ? response.data.addInternalUserv2.email.replace('onewp_', '')
          : response.data.addInternalUserv2.email;
        setNewUserEmail(mail);
        setLoaderState(true); // Vrati loader state natrag
        // Ne zatvaraj modal, prikaži client access opcije
      } else {
        throw new Error('User was not created');
      }
    } catch (e) {
      console.log('ERROR IN ADDING USER', e);
      setLoaderState(true);
      showErrorToast('Error creating internal user. Please try again.');
    }
  }

  async function createNewExternalUser() {
    try {
      const response = (await API.graphql({
        query: addExternalUser,
        variables: {
          Email: mail,
          Name: firstName,
          Family_name: lastName,
          Organization_id: activeOrganization?.OrganizationId,
          Environment: getEnvironment,
          Agency: `${REACT_APP_AGENCY?.toUpperCase()}`,
          WelcomeUrl: `https://nordics.${REACT_APP_AGENCY_URL}.com`,
          Dashboards: selectedDashboards,
          // Ne šaljemo Clients ovdje
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: AddExternalUserMutation };

      if (response.data.addExternalUser?.email) {
        setNewUserCreated(true);
        setNewUserEmail(response.data.addExternalUser.email);
        setLoaderState(true); // Vrati loader state natrag
        // Ne zatvaraj modal, prikaži client access opcije
      } else {
        throw new Error('User was not created');
      }
    } catch (e) {
      console.log('ERROR IN ADDING USER', e);
      setLoaderState(true);
      showErrorToast('Error creating external user. Please try again.');
    }
  }

  const finishUserCreation = () => {
    props.setSeeModal(!props.seeModal);
    props.callBothUsers();
    // Reset state
    setNewUserCreated(false);
    setNewUserEmail('');
  };

  // HANDLING CLIENT CODES - real-time API calls za postojeće korisnike
  const handleCodes = async (e: any, event: any) => {
    const previousValue = e.AccessType;
    const newValue = event.target.value;
    const clientCode = e.ClientCode;
    const clientCountry = e.ClientCountry;

    // Optimistički ažuriraj lokalno stanje
    updateLocalAccessType(clientCode, newValue);
    // Odredi username: za postojeće korisnike ili nove nakon kreacije
    const email = props.modifyUser?.Email ?? (newUserCreated ? newUserEmail : undefined);
    console.log('EMAIL', props.modifyUser, newUserCreated, newUserEmail);
    if (!email) {
      return;
    }
    // Pozovi API odmah za svaku promjenu
    setLoadingClients((prev) => new Set(prev).add(clientCode));
    try {
      await API.graphql({
        query: updateUserAccess,
        variables: {
          Environment: getEnvironment,
          Email: email,
          Clients: [{ ClientCode: clientCode, ClientCountry: clientCountry, AccessType: newValue }],
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      });
    } catch (error) {
      console.error('Error updating user access:', error);
      // Vrati prethodno stanje na grešku
      updateLocalAccessType(clientCode, previousValue);
      showErrorToast(`Error updating access for ${clientCode}. Please try again.`);
    } finally {
      setLoadingClients((prev) => {
        const newSet = new Set(prev);
        newSet.delete(clientCode);
        return newSet;
      });
    }
  };

  // Helper funkcija za ažuriranje lokalnog stanja
  const updateLocalAccessType = (clientCode: string, accessType: string) => {
    setFullList(
      (ps: any) =>
        ps?.map((obj: any) => {
          if (obj.ClientCode === clientCode) {
            return { ...obj, AccessType: accessType };
          }
          return obj;
        }) || [],
    );

    setReadList(
      (ps: any) =>
        ps?.map((obj: any) => {
          if (obj.ClientCode === clientCode) {
            return { ...obj, AccessType: accessType };
          }
          return obj;
        }) || [],
    );
  };

  // Helper funkcija za prikazivanje error toast-a
  const showErrorToast = (message: string) => {
    setErrorToast({ show: true, message });
    setTimeout(() => {
      setErrorToast({ show: false, message: '' });
    }, 3000);
  };

  const closeModal = () => {
    props.setModifyUser(undefined);
    props.setSeeModal(!props.seeModal);
    props.setModifyUserAccessLevels(undefined);
    // Reset state za novi korisnik
    setNewUserCreated(false);
    setNewUserEmail('');
    setErrorToast({ show: false, message: '' });
  };

  const [loaderState, setLoaderState] = useState(true);
  const themes = useTheme();

  const isItReadPlus = (code: string) => {
    const getLevel = props.typeOfReadAccess.find((e) => e.ClientCode === code);
    if (getLevel?.Level === 'READ_PLUS_ACCESS') return '#DAA520';
    else return '#FFEE00';
  };

  return (
    <Modal onClick={() => closeModal()}>
      {loaderState ? (
        <HeadModul onClick={(e) => e.stopPropagation()}>
          <button type="button" className="x" onClick={() => closeModal()}>
            {' '}
            <IoMdClose className="closeIcon" />
          </button>

          <ModulContainer onClick={(e) => e.stopPropagation()}>
            <h1>
              {props.modifyUser !== undefined
                ? 'Modify User Access'
                : newUserCreated
                  ? 'Set Client Access'
                  : 'Add User'}
            </h1>
            {/* Prikaži osnovne podatke samo za nove korisnike koji nisu još kreirani */}
            {props.modifyUser === undefined &&
              !newUserCreated &&
              (props.userType === 'INTERNAL' ? (
                <div className="form">
                  <div className="inputFieldLastMail">
                    <label htmlFor="">
                      Email
                      <input defaultValue={mail} onChange={(e) => setMail(e.target.value)} type="text" />
                    </label>
                  </div>
                  <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="country-select">Country</label>
                      <StyledDropdown
                        id="country-select"
                        value={selectedCountry}
                        onChange={(e) => setSelectedCountry(e.target.value as countryEnum)}
                      >
                        {Object.values(countryEnum)
                          .filter((c) => ['DK', 'NO', 'FI', 'SE'].includes(c))
                          .map((c) => (
                            <option key={c} value={c}>
                              {c}
                            </option>
                          ))}
                      </StyledDropdown>
                    </div>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="agency-select">Agency</label>
                      <StyledDropdown
                        id="agency-select"
                        value={selectedAgency}
                        onChange={(e) => setSelectedAgency(e.target.value as agencyEnum)}
                      >
                        {Object.values(agencyEnum).map((a) => (
                          <option key={a} value={a}>
                            {a}
                          </option>
                        ))}
                      </StyledDropdown>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="form">
                  <div className="namesForm">
                    <div className="inputFieldName">
                      <label>
                        First Name
                        <input defaultValue={firstName} onChange={(e) => setFirstName(e.target.value)} type="text" />
                      </label>
                    </div>
                    <div className="inputFieldLastName">
                      <label>
                        Last Name
                        <input defaultValue={lastName} onChange={(e) => setLastName(e.target.value)} type="text" />
                      </label>
                    </div>
                  </div>
                  <div className="inputFieldLastMail">
                    <label>
                      Email
                      <input defaultValue={mail} onChange={(e) => setMail(e.target.value)} type="text" />
                    </label>
                  </div>
                </div>
              ))}

            {/* Prikaži podatke korisnika za postojeće korisnike */}
            {props.modifyUser !== undefined && (
              <div className="form">
                <div className="namesForm">
                  <div className="inputFieldName" style={{ float: 'left' }}>
                    <label htmlFor="">
                      First Name
                      <input
                        defaultValue={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        type="text"
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="inputFieldLastName" style={{ float: 'left', alignSelf: 'flex-end' }}>
                    <label htmlFor="">
                      Last Name
                      <input
                        defaultValue={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        type="text"
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>
                <div className="inputFieldLastMail" style={{ float: 'left' }}>
                  <label htmlFor="">
                    Email
                    <input defaultValue={mail} onChange={(e) => setMail(e.target.value)} type="text" disabled={true} />
                  </label>
                </div>
              </div>
            )}

            {/* Prikaži poruku da je korisnik kreiran */}
            {newUserCreated && (
              <div
                style={{
                  padding: '1rem',
                  margin: '1rem 4vw',
                  backgroundColor: '#d4edda',
                  border: '1px solid #c3e6cb',
                  borderRadius: '7px',
                  color: '#155724',
                }}
              >
                ✓ User has been successfully created! You can now set up access for client codes.
              </div>
            )}

            {/* Prikaži client access selector samo za postojeće korisnike ili novo kreirane korisnike */}
            {(props.modifyUser !== undefined || newUserCreated) && (
              <div className="selectorsForm">
                <div className="toggler">
                  <h3 style={{ width: '200px' }}>Select access type on client code:</h3>
                  <div className="onoff">
                    {fullList?.map((e: any, i: any) => (
                      <section key={e.ClientCode}>
                        <legend>
                          {e.ClientCode ?? ''}
                          {loadingClients.has(e.ClientCode) && (
                            <span style={{ marginLeft: '8px', fontSize: '10px', color: '#20C933' }}>Updating...</span>
                          )}
                        </legend>
                        <div style={{ display: 'flex' }}>
                          {props.userType === 'INTERNAL' && (
                            <>
                              <input
                                type="radio"
                                id={i + 'full'}
                                name={e.ClientCode}
                                value="FULL"
                                checked={e.AccessType === 'FULL'}
                                disabled={loadingClients.has(e.ClientCode)}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCodes(e, event)}
                              />
                              <label
                                style={{
                                  color: e.AccessType === 'FULL' ? '#20C933' : '',
                                  opacity: loadingClients.has(e.ClientCode) ? 0.6 : 1,
                                }}
                                htmlFor={i + 'full'}
                                className="midChild"
                              >
                                Full access
                              </label>
                            </>
                          )}

                          <input
                            type="radio"
                            id={i + 'read'}
                            name={e.ClientCode}
                            value="READ"
                            checked={e.AccessType === 'READ'}
                            disabled={loadingClients.has(e.ClientCode)}
                            onChange={(event) => handleCodes(e, event)}
                          />
                          <label
                            style={{
                              color: e.AccessType === 'READ' ? isItReadPlus(e.ClientCode) : '',
                              opacity: loadingClients.has(e.ClientCode) ? 0.6 : 1,
                            }}
                            htmlFor={i + 'read'}
                            className="midChild"
                          >
                            Read access
                          </label>

                          <input
                            type="radio"
                            id={i + 'no'}
                            name={e.ClientCode}
                            value="NONE"
                            checked={e.AccessType === 'NONE'}
                            disabled={loadingClients.has(e.ClientCode)}
                            onChange={(event) => handleCodes(e, event)}
                          />
                          <label
                            style={{
                              color: e.AccessType === 'NONE' ? '#FF0021' : '',
                              opacity: loadingClients.has(e.ClientCode) ? 0.6 : 1,
                            }}
                            htmlFor={i + 'no'}
                          >
                            No access
                          </label>
                        </div>
                      </section>
                    ))}

                    {readList?.map((e: any, i: any) => (
                      <section key={e.ClientCode}>
                        <legend>
                          {e.ClientCode}
                          {loadingClients.has(e.ClientCode) && (
                            <span style={{ marginLeft: '8px', fontSize: '10px', color: '#20C933' }}>Updating...</span>
                          )}
                        </legend>
                        <div style={{ display: 'flex' }}>
                          <input
                            type="radio"
                            id={i + 'read'}
                            name={e.ClientCode}
                            value="READ"
                            checked={e.AccessType === 'READ'}
                            disabled={loadingClients.has(e.ClientCode)}
                            onChange={(event) => handleCodes(e, event)}
                          />
                          <label
                            style={{
                              color: e.AccessType === 'READ' ? isItReadPlus(e.ClientCode) : '',
                              opacity: loadingClients.has(e.ClientCode) ? 0.6 : 1,
                            }}
                            htmlFor={i + 'read'}
                            className="midChild"
                          >
                            Read access
                          </label>

                          <input
                            type="radio"
                            id={i + 'no'}
                            name={e.ClientCode}
                            value="NONE"
                            checked={e.AccessType === 'NONE'}
                            disabled={loadingClients.has(e.ClientCode)}
                            onChange={(event) => handleCodes(e, event)}
                          />
                          <label
                            style={{
                              color: e.AccessType === 'NONE' ? '#FF0021' : 'initial',
                              opacity: loadingClients.has(e.ClientCode) ? 0.6 : 1,
                            }}
                            htmlFor={i + 'no'}
                          >
                            No access
                          </label>
                        </div>
                      </section>
                    )) || []}
                  </div>
                </div>
              </div>
            )}
          </ModulContainer>

          <DarkButton style={{ alignSelf: 'flex-end' }} type="button" onClick={handleSaveButton}>
            {props.modifyUser !== undefined ? 'CLOSE' : newUserCreated ? 'FINISH' : 'CREATE USER'}
          </DarkButton>
        </HeadModul>
      ) : (
        <div className="loaderDiv">
          <ReactLoading type="spinningBubbles" color={themes.publishButton}></ReactLoading>
        </div>
      )}

      {/* Error Toast */}
      {errorToast.show && (
        <StatusToast isError={true}>
          <div className="colorIndicator" />
          <div>{errorToast.message}</div>
        </StatusToast>
      )}
    </Modal>
  );
};

export default UserAdminModal2;
